import { render, staticRenderFns } from "./modalView.vue?vue&type=template&id=f95a0378"
import script from "./modalView.vue?vue&type=script&lang=js"
export * from "./modalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports